export default function StoriesFromTheField() {
  return null;
}